import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { ConfirmationService } from "primeng/api";
import { FacebookApiresponceObject, ResponseObject } from "src/app/Services/auth.service";
import { FacebookService } from "src/app/Services/facebook.service";
import { InstagramService } from "src/app/Services/instagram.service";
import { NotificationsService } from "src/app/Services/shared/notifications.service";
import { SocialPostService } from "src/app/Services/social-post.service";
import { NotificationTypes } from "src/app/app.enums";
import { FacebookAccount, FaceBookOuthPage, FaceBookOuthPages, FacebookProfie, InstagramOuthPage, ResponeObject, SocialPostData } from "src/app/models/socialpost.model";
import { TranslocoService } from "@jsverse/transloco";

@Component({
    selector: 'social-account',
    templateUrl: './social-account.component.html',
    standalone: false
})

export class SocialAccountComponent implements OnInit {
  public socialAccounts: SocialPostData[] = [];
  public Account!: SocialPostData;
  public socialAccountLoading: boolean = false;
  public facebookPagesLoading: boolean = false;
  public instagramPagesLoading: boolean = false;
  public isSocialAccountConnected: boolean = false;
  public isViewPagesVisible: boolean = false
  public Instagram: boolean = false;
  public IsActived: boolean = true;
  public FacebookProfilePicture!: string[];
  public FaceBookName!: string[];
  public FaceBookEmail!: string[];
  public FacebookPageId!: string;
  public facebookPages: FaceBookOuthPages[] = [];
  public instagramPages: InstagramOuthPage[] = [];
  public isInstagramAccount: boolean = false;
  public isFacebookAccount: boolean = false;
  public facebookAccountDetail: FacebookAccount = {
    Id: "",
    UserId: "",
    FaceBookId: "",
    FaceBookName: "",
    FaceBookEmail: "",
    FacebookProfilePicture: "",
    FacebookAccessTokken: "",
    IsActive: false,
    CreatedDate: new Date(),
    FaceBookOuthPages: []
  };

  constructor(
    private SocialPostService: SocialPostService,
    private router: Router,
    private ngxSpinnerService: NgxSpinnerService,
    private confirmationService: ConfirmationService,
    private notificationsService: NotificationsService,
    private instagramService: InstagramService,
    private facebookService: FacebookService,
    private transloco: TranslocoService) {

  }

  ngOnInit(): void {
    this.IsActived = true
    this.getConnectedFacebookAccounts();
    
  }
  onImageError(event: any) {
    event.target.src = 'assets/images/No-Image.png'; 
  }

  public onConnectFacebookAccount() {
    this.ngxSpinnerService.show();
    this.facebookService.onloginWithFacebook().subscribe((responce: ResponseObject) => {
      console.log("responce", responce)
      if (responce.Success) {
        window.location.href = responce.ResponseData;
      } else {
        this.ngxSpinnerService.hide();
        console.error("Failed to get redirect URL");
      }
      this.ngxSpinnerService.hide();
    }, (error) => {
      console.error("Error during Facebook login:", error);
      this.ngxSpinnerService.hide(); // Hide spinner in case of error
    })
  }

  public onConnectInstagramAccount() {
    this.instagramService.onloginWithInstagram().subscribe((responce: ResponseObject) => {
      if (responce.Success) {
        window.location.href = responce.ResponseData;
      }
    }, (error) => { console.error(error) })
  }

  public getConnectedFacebookAccounts() {
    // this.isSocialAccountConnected = false
    this.ngxSpinnerService.show();
    // this.IsActived = true
    this.facebookService.onGetAllFacebookAccounts().subscribe((FacebokAccountApiResponce: FacebookAccount) => {
      console.log(FacebokAccountApiResponce);
      if (FacebokAccountApiResponce) {
        this.ngxSpinnerService.hide();
        this.facebookAccountDetail.Id = FacebokAccountApiResponce.Id
        this.facebookAccountDetail.UserId = FacebokAccountApiResponce.UserId
        this.facebookAccountDetail.FaceBookId = FacebokAccountApiResponce.FaceBookId
        this.facebookAccountDetail.FaceBookName = FacebokAccountApiResponce.FaceBookName
        this.facebookAccountDetail.FaceBookEmail = FacebokAccountApiResponce.FaceBookEmail
        this.facebookAccountDetail.FacebookProfilePicture = FacebokAccountApiResponce.FacebookProfilePicture
        this.facebookAccountDetail.IsActive = FacebokAccountApiResponce.IsActive
        this.facebookAccountDetail.CreatedDate = FacebokAccountApiResponce.CreatedDate
        this.facebookPages = FacebokAccountApiResponce.FaceBookOuthPages
        console.log(this.facebookPages)
      } else {
        this.facebookAccountDetail = {} as FacebookAccount
        this.facebookPages = []
        this.ngxSpinnerService.hide();
      }
    }, (error) => {
      if (error.status === 204) {
        // Jab 204 aaye to facebookAccountDetail ko null set karein.
        this.facebookAccountDetail = {} as FacebookAccount;
      } else {
        console.error('Error fetching Facebook details:', error);
        this.ngxSpinnerService.hide();
      }
    })
  }

  public getDeactiveSocialAccounts(isDeactivated: boolean) {
    this.IsActived = !isDeactivated;
    this.getConnectedFacebookAccounts();
  }

  public onDeactivateAccount(Id: string, AccountOf: string) {
    console.log(Id)
    console.log(AccountOf)
    this.confirmationService.confirm({
      message: this.transloco.translate('socialAccount.disconnectAccountConfirm', { account: AccountOf }),
      accept: () => {
        this.ngxSpinnerService.show();
        this.SocialPostService.onDeactiveAccount(Id, AccountOf).subscribe((response: ResponseObject) => {
          this.ngxSpinnerService.hide();
          console.log(response)
          if (response.Success) {
            var index = this.socialAccounts.findIndex(p => p.Id == Id)
            if (index !== -1) {
              this.socialAccounts.splice(index, 1)
              // this.isSocialAccountConnected = false
            }
            this.notificationsService.showNotification(this.transloco.translate('socialAccount.successTitle'), this.transloco.translate('socialAccount.accountDeactivatedSuccess'), NotificationTypes.Success);
          } else { this.notificationsService.showNotification(this.transloco.translate('socialAccount.errorTitle'), response.ResponseMessage, NotificationTypes.Error); }
        }, (error) => { console.error(error); this.ngxSpinnerService.hide(); this.notificationsService.showNotification(this.transloco.translate('socialAccount.errorTitle'), this.transloco.translate('socialAccount.deactivateAccountError'), NotificationTypes.Error); });
      },
    });
  }

  public onReconnectAccount(Id: string, AccountOf: string) {
    console.log(Id)
    console.log(AccountOf)
    this.ngxSpinnerService.show();
    this.SocialPostService.onReconnectAccount(Id, AccountOf).subscribe((response: ResponseObject) => {
      this.ngxSpinnerService.hide();
      console.log(response)
      if (response.Success) {
        window.location.href = response.ResponseData
        setTimeout(() => {
          this.notificationsService.showNotification(this.transloco.translate('socialAccount.successTitle'), this.transloco.translate('socialAccount.accountReconnectedSuccess'), NotificationTypes.Success);
        }, 5000)

      } else { this.notificationsService.showNotification(this.transloco.translate('socialAccount.errorTitle'), response.ResponseMessage, NotificationTypes.Error); }
    }, (error) => { console.error(error); this.ngxSpinnerService.hide(); this.notificationsService.showNotification(this.transloco.translate('socialAccount.errorTitle'), this.transloco.translate('socialAccount.deactivateAccountError'), NotificationTypes.Error); });
  }
  public goToFacebookPage(pageLink: string): void {
    // window.location.href = pageLink;
    window.open(pageLink, '_blank')
  }

  public onDisconnectFacebookAccount(Id: string | undefined) {
    this.confirmationService.confirm({
      message: this.transloco.translate('socialAccount.deactivateFacebookConfirm', { account: this.facebookAccountDetail.FaceBookName }),
      accept: () => {
        this.ngxSpinnerService.show();
        console.log(Id)
        this.facebookService.onDeactiveAccount(Id!).subscribe((response) => {
          this.ngxSpinnerService.hide();
          if (response.Success) {
            this.facebookAccountDetail = {} as FacebookAccount
            this.facebookPages = []
            this.getConnectedFacebookAccounts()
            this.notificationsService.showNotification(this.transloco.translate('socialAccount.successTitle'), response.ResponseMessage, NotificationTypes.Success);
          } else { this.notificationsService.showNotification(this.transloco.translate('socialAccount.errorTitle'), response.ResponseMessage, NotificationTypes.Error); }
        }, (error) => { console.error(error); this.ngxSpinnerService.hide(); this.notificationsService.showNotification(this.transloco.translate('socialAccount.errorTitle'), this.transloco.translate('socialAccount.deleteProductError'), NotificationTypes.Error); });
      },
    });
  }
  onDeleteFacebookAccount() {
    const Id = this.facebookAccountDetail.Id;
    this.router.navigate(['/delete-meta'], { queryParams: { Id } });
  }
}